// Italian translations
export const it: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Pannello di Controllo',
  'menu.orderNew': 'Registrazione Prodotto',
  'menu.deliveryList': 'Elenco Consegne',
  'menu.delivery': 'Consegna',
  'menu.receipt': 'Stampa Scontrino/Etichetta',
  'menu.carWash': 'Autolavaggio',
  'menu.referral': 'Invita',
  'menu.driverPickup': 'Ritiri da effettuare',
  'menu.payment': 'Pagamento',
  'menu.reportsCharts': 'Report grafici',
  'menu.barber': 'Barbiere / Parrucchiere',
  
  // Definitions
  'menu.definitions': 'Definizioni',
  'menu.customers': 'Clienti',
  'menu.products': 'Definizioni Prodotti',
  'menu.pricing': 'Definizioni Prezzi',
  'menu.tailoring': 'Operazioni di Sartoria',
  'menu.attributes': 'Attributi Prodotti',
  'menu.users': 'Utenti',
  'menu.productOrdering': 'Ordinamento Prodotti',
  'menu.discounts': 'Definizioni Sconti',
  
  // Settings
  'menu.settings': 'Impostazioni',
  'menu.generalSettings': 'Impostazioni Generali',
  'menu.permissions': 'Gestione Permessi',
  'menu.subscription': 'Abbonamento',
  'menu.invoices': 'Gestione Fatture',
  'menu.expenses': 'Inserimento Spese',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Report e Contabilità',
  'menu.systemAndCommunication': 'Sistema e Comunicazione',
  'menu.reportsList': 'Elenco Scontrini',
  'menu.accountStatement': 'Estratto Conto',
  'menu.tickets': 'Richieste di Supporto',
  'menu.support': 'Supporto',
  'menu.profile': 'Profilo',
  'menu.logout': 'Esci',
  'menu.notifications': 'Notifiche SMS/WhatsApp',
  'menu.whatsappConnection': 'Connessione WhatsApp',
  'menu.smsConnection': 'Connessione SMS',
  'menu.hardware': 'Hardware',
  
  // Dashboard
  'dashboard.title': 'Pannello di Controllo',
  'dashboard.todaySales': 'Vendite di Oggi',
  'dashboard.totalOrders': 'Totale Ordini',
  'dashboard.pendingDeliveries': 'Consegne in Corso',
  'dashboard.activeCustomers': 'Clienti Attivi',
  'dashboard.recentOrders': 'Ordini Recenti',
  'dashboard.viewAll': 'Vedi Tutto',
  'dashboard.quickActions': 'Azioni Rapide',
  'dashboard.newOrder': 'Nuovo Ordine',
  'dashboard.newCustomer': 'Nuovo Cliente',
  'dashboard.deliveries': 'Consegne',
  'dashboard.reports': 'Rapporti',
  'dashboard.today': 'Oggi',
  'dashboard.yesterday': 'Ieri',
  'dashboard.week': 'Settimana',
  'dashboard.month': 'Mese',
  'dashboard.quarter': 'Trimestre',
  'dashboard.year': 'Anno',
  'dashboard.totalRevenue': 'Fatturato Totale',
  'dashboard.totalOrdersCard': 'Totale Ordini',
  'dashboard.totalPieces': 'Totale Pezzi',
  'dashboard.cancelled': 'Annullato',
  'dashboard.inProcess': 'In Lavorazione',
  'dashboard.inProcessDesc': 'Ordini in lavorazione',
  'dashboard.ready': 'Pronto',
  'dashboard.readyDesc': 'Ordini pronti per la consegna',
  'dashboard.delivered': 'Consegnato',
  'dashboard.deliveredDesc': 'Ordini completati',
  'dashboard.announcements': 'Annunci',
  'dashboard.announcementAll': 'Generale',
  'dashboard.announcementPrivate': 'Privato',
  
  // Order Entry
  'order.title': 'Nuovo Ordine',
  'order.customer': 'Cliente',
  'order.selectCustomer': 'Seleziona Cliente',
  'order.newCustomer': 'Nuovo Cliente',
  'order.products': 'Prodotti',
  'order.addProduct': 'Aggiungi Prodotto',
  'order.selectProduct': 'Seleziona Prodotto',
  'order.quantity': 'Quantità',
  'order.price': 'Prezzo',
  'order.total': 'Totale',
  'order.discount': 'Sconto',
  'order.subtotal': 'Subtotale',
  'order.tax': 'IVA',
  'order.grandTotal': 'Totale Generale',
  'order.payment': 'Pagamento',
  'order.paymentMethod': 'Metodo di Pagamento',
  'order.cash': 'Contanti',
  'order.card': 'Carta di Credito',
  'order.credit': 'A Credito',
  'order.amountPaid': 'Importo Pagato',
  'order.remainingBalance': 'Saldo Rimanente',
  'order.deliveryDate': 'Data di Consegna',
  'order.notes': 'Note',
  'order.createOrder': 'Crea Ordine',
  'order.cancel': 'Annulla',
  
  // Users
  'users.title': 'Utenti',
  'users.addNew': 'Nuovo Utente',
  'users.name': 'Nome Cognome',
  'users.email': 'E-mail',
  'users.role': 'Ruolo',
  'users.pin': 'PIN',
  'users.permissions': 'Permessi',
  'users.allPermissions': 'Tutti i Permessi',
  'users.permissionCount': '{count} permessi',
  'users.changePin': 'Cambia PIN',
  'users.edit': 'Modifica',
  'users.delete': 'Elimina',
  'users.newUser': 'Nuovo Utente',
  'users.editUser': 'Modifica Utente',
  'users.editingUser': 'Modifica di {name}',
  'users.deleteUserTitle': 'Elimina Utente',
  'users.deletingUser': 'Sei sicuro di voler eliminare {name}?',
  'users.pinCode': 'Codice PIN (4-6 cifre)',
  'users.selectRole': 'Seleziona ruolo',
  'users.patron': 'Proprietario',
  'users.kasiyer': 'Cassiere',
  'users.sofor': 'Autista',
  'users.eleman': 'Dipendente',
  'users.changePinTitle': 'Cambia Codice PIN',
  'users.newPin': 'Nuovo Codice PIN',
  'users.confirmPin': 'Conferma Codice PIN',
  'users.pinMismatch': 'I codici PIN non corrispondono',
  'users.pinRequired': 'Codice PIN richiesto',
  'users.pinLength': 'Il codice PIN deve contenere 4-6 cifre',
  'users.changingPinFor': 'Modifica del PIN per {name}',
  
  // Products
  'products.title': 'Definizioni Prodotti',
  'products.addNew': 'Nuovo Prodotto',
  'products.category': 'Categoria',
  'products.name': 'Nome Prodotto',
  'products.price': 'Prezzo',
  'products.color': 'Colore',
  'products.active': 'Attivo',
  'products.actions': 'Azioni',
  'products.search': 'Cerca Prodotto...',
  'products.noProducts': 'Nessun prodotto trovato',
  'products.noCategoryProducts': 'Nessun prodotto in questa categoria',
  'products.emptyCart': 'Carrello vuoto',
  
  // Service Types
  'service.tailor': 'Sartoria',
  'service.dryCleaning': 'Lavaggio a Secco',
  'service.washing': 'Lavaggio',
  'service.ironing': 'Stiratura',
  'service.dyeing': 'Tintura',
  'service.dyeingShort': 'Tintura',
  'service.shoeShine': 'Lucidatura Scarpe',
  'service.carpet': 'Tappeto',
  'service.tailoring': 'Ritocchi Sartoriali',
  'service.carpetWashing': 'Lavaggio Tappeti',
  'service.sofaWashing': 'Lavaggio Divani',
  'service.carWash': 'Autolavaggio & Detailing',
  'service.barber': 'Barbiere / Parrucchiere',
  'service.selectService': 'Seleziona servizio',
  'service.addToCart': 'Aggiungi al Carrello',
  'service.total': 'Totale',
  
  // Order Create Page
  'orderCreate.cart': 'Carrello',
  'orderCreate.totalPieces': 'Totale Pezzi',
  'orderCreate.plannedDelivery': 'Consegna Prevista',
  'orderCreate.payment': 'Pagamento',
  'orderCreate.save': 'Salva',
  'orderCreate.continue': 'Continua',
  // Area Calculation Dialog
  'areaCalculation.title': 'Area Calculation',
  'areaCalculation.carpetCount': '🔢 Carpet Count',
  'areaCalculation.carpetCountPlaceholder': 'How many carpets?',
  'areaCalculation.directInput': '📏 Enter m² Directly',
  'areaCalculation.totalSqM': '📏 Total m² (for {count} carpets)',
  'areaCalculation.exampleSqM': 'Ex: 12.5',
  'areaCalculation.or': 'OR',
  'areaCalculation.width': 'Width (m)',
  'areaCalculation.height': 'Height (m)',
  'areaCalculation.exampleNumber': 'Ex: 4',
  'areaCalculation.calculatedArea': 'Calculated Area:',
  'areaCalculation.perCarpet': 'Per carpet',
  'areaCalculation.total': 'Total',
  'areaCalculation.continue': 'Continue',

  'orderCreate.allCategories': 'Tutti',
  'orderCreate.selectCustomer': 'Seleziona Cliente',
  'orderCreate.selectCustomerPlaceholder': 'Seleziona cliente',
  'orderCreate.change': 'Modifica',
  'orderCreate.select': 'Seleziona',
  'orderCreate.balance': 'Saldo',
  'orderCreate.searchCustomer': 'Cerca per nome, telefono o indirizzo...',
  'orderCreate.newCustomer': 'Nuovo Cliente',
  'orderCreate.customerName': 'Nome Cognome',
  'orderCreate.customerPhone': 'Telefono',
  'orderCreate.customerEmail': 'E-mail',
  'orderCreate.customerAddress': 'Indirizzo',
  'orderCreate.addCustomer': 'Aggiungi Cliente',
  'orderCreate.customer': 'Cliente',
  'orderCreate.serviceType': 'Tipo di Servizio',
  'orderCreate.clickToSelect': 'Clicca per selezionare',
  'orderCreate.deliveryDate': 'Data di Consegna',
  'orderCreate.details': 'Dettaglio',
  'orderCreate.itemDetails': 'Dettagli',
  'orderCreate.tailoringOperations': 'Operazioni di Sartoria',
  'orderCreate.tailoringTitle': 'Operazioni di Sartoria',
  
  // Pricing Page
  'pricing.title': 'Definizioni Prezzi',
  'pricing.search': 'Cerca Prodotto...',
  'pricing.product': 'Prodotto',
  'pricing.dryCleaning': 'Lavaggio a Secco',
  'pricing.washing': 'Lavaggio',
  'pricing.ironing': 'Stiratura',
  'pricing.dyeing': 'Tintura',
  'pricing.tailoring': 'Ritocchi Sartoriali',
  'pricing.shoeShine': 'Lucidatura Scarpe',
  'pricing.action': 'Azione',
  'pricing.save': 'Salva',
  'pricing.saving': 'Salvataggio...',
  'pricing.pricesSaved': 'Prezzi salvati',
  'pricing.pricesSaveError': 'Impossibile salvare i prezzi',
  'pricing.noProducts': 'Nessun prodotto trovato',
  'pricing.loadError': 'Impossibile caricare i prodotti',
  
  // Tailoring Page
  'tailoring.title': 'Operazioni di Sartoria',
  'tailoring.addNew': 'Nuova Operazione',
  
  // Attributes Page
  'attributes.title': 'Attributi Prodotti',
  'attributes.colors': 'Colori',
  'attributes.stains': 'Tipi di Macchie',
  'attributes.damages': 'Tipi di Danni',
  'attributes.add': 'Aggiungi',
  
  // Permissions Page
  'permissions.title': 'Gestione Permessi',
  'permissions.subtitle': 'Definisci i permessi per i ruoli proprietario e cassiere',
  'permissions.about': 'Informazioni sulla Gestione Permessi',
  'permissions.patronInfo': '<strong>Proprietario:</strong> Ruolo amministratore principale con tutti i permessi di sistema.',
  'permissions.cashierInfo': '<strong>Cassiere:</strong> Ruolo utente con permessi limitati per le operazioni quotidiane.',
  'permissions.saveSuccess': 'Permessi salvati',
  'permissions.saveError': 'Impossibile salvare i permessi',
  'permissions.patron': 'Proprietario',
  'permissions.cashier': 'Cassiere',
  'permissions.patronRole': 'Amministratore con tutti i permessi',
  'permissions.cashierRole': 'Utente con permessi limitati',
  'permissions.activePermissions': 'Permessi Attivi:',
  'permissions.selectAllPatron': 'Seleziona Tutto Proprietario',
  'permissions.deselectAllPatron': 'Deseleziona Tutto Proprietario',
  'permissions.selectAllCashier': 'Seleziona Tutto Cassiere',
  'permissions.deselectAllCashier': 'Deseleziona Tutto Cassiere',
  'permissions.saving': 'Salvataggio...',
  'permissions.permissionList': 'Elenco Permessi',
  'permissions.infoTitle': 'Informazioni sulla Gestione Permessi',
  'permissions.infoText1': 'Ruolo amministratore principale con tutti i permessi di sistema.',
  'permissions.infoText2': 'Ruolo utente con permessi limitati per le operazioni quotidiane.',
  'permissions.infoText3': 'Le modifiche non saranno effettive finché non vengono salvate.',
  'permissions.infoText4': 'I permessi possono essere personalizzati per ogni ruolo.',
  
  // Driver Dashboard Page
  'driver.title': 'Pannello Autista',
  'driver.todayRevenue': 'Fatturato Giornaliero',
  'driver.totalPieces': 'Totale Pezzi',
  'driver.pending': 'In Corso',
  'driver.ready': 'Pronto',
  'driver.pickup': 'Ritiro Prodotto',
  
  // Subscription Page
  'subscription.title': 'Piani di Abbonamento',
  'subscription.currentPlan': 'Il Tuo Piano Attuale',
  'subscription.upgradePlan': 'Aggiorna',
  'subscription.downgradePlan': 'Downgrade',
  'subscription.choosePlan': 'Scegli Piano',
  'subscription.billingCycle': 'Ciclo di Fatturazione',
  'subscription.monthly': 'Mensile',
  'subscription.yearly': 'Annuale',
  'subscription.perMonth': '/mese',
  'subscription.perYear': '/anno',
  'subscription.plusVAT': '+ IVA',
  'subscription.save': 'Risparmia {percent}%',
  'subscription.mostPopular': 'Il Più Popolare',
  'subscription.freeTrial': '{months} mese gratuito',
  'subscription.featuresIncluded': 'Funzionalità incluse:',
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Perfetto per piccole imprese',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Per aziende in crescita',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Soluzioni aziendali',
  'subscription.maxReceipts': 'Massimo {count} ricevute/mese',
  'subscription.maxUsers': '{count} account utente',
  'subscription.whatsappCredits': '🎁 {count} crediti WhatsApp in regalo',
  'subscription.basicReports': 'Report di base',
  'subscription.advancedReports': 'Report avanzati',
  'subscription.customReports': 'Report personalizzati',
  'subscription.whatsappIntegration': 'Integrazione WhatsApp',
  'subscription.supportTicket': 'Tempo di risposta ticket: {hours} ore',
  'subscription.supportTicketBusiness': 'Tempo di risposta ticket: {hours} ore (orario lavorativo)',
  'subscription.accountManagement': 'Gestione account',
  'subscription.driverApp': 'App mobile autista',
  'subscription.prioritySupport': 'Supporto prioritario',
  'subscription.managerApp': 'App mobile - vista manager',
  'subscription.paymentTitle': 'Completa il Pagamento',
  'subscription.planSelection': 'Piano Selezionato',
  'subscription.billingPeriod': 'Periodo di Fatturazione',
  'subscription.month': 'mese',
  'subscription.year': 'anno',
  'subscription.subtotal': 'Subtotale',
  'subscription.tax': 'IVA ({rate}%)',
  'subscription.total': 'Totale',
  'subscription.couponCode': 'Codice Coupon',
  'subscription.applyCoupon': 'Applica',
  'subscription.removeCoupon': 'Rimuovi',
  'subscription.discount': 'Sconto',
  'subscription.invalidCoupon': 'Codice coupon non valido',
  'subscription.couponVerificationFailed': 'Verifica coupon fallita',
  'subscription.couponRemoved': 'Coupon rimosso',
  'subscription.billingInfo': 'Informazioni di Fatturazione',
  'subscription.companyName': 'Nome Azienda',
  'subscription.companyNamePlaceholder': 'Inserisci nome azienda',
  'subscription.taxNumber': 'Partita IVA',
  'subscription.taxNumberPlaceholder': 'Inserisci partita IVA',
  'subscription.phone': 'Telefono',
  'subscription.phonePlaceholder': 'Inserisci numero di telefono',
  'subscription.address': 'Indirizzo',
  'subscription.addressPlaceholder': 'Inserisci indirizzo di fatturazione',
  'subscription.corporateInvoice': 'Fattura Aziendale',
  'subscription.individualInvoice': 'Fattura Individuale',
  'subscription.paymentMethod': 'Metodo di Pagamento',
  'subscription.creditCard': 'Carta di Credito',
  'subscription.bankTransfer': 'Bonifico Bancario',
  'subscription.cardNumber': 'Numero Carta',
  'subscription.cardNumberPlaceholder': 'Inserisci numero carta',
  'subscription.expiryDate': 'Data di Scadenza',
  'subscription.cvc': 'CVC',
  'subscription.completePayment': 'Completa il Pagamento',
  'subscription.processing': 'Elaborazione...',
  'subscription.redirectingToPayment': 'Reindirizzamento alla pagina di pagamento...',
  'subscription.paymentSuccess': '✅ Pagamento riuscito! Il tuo abbonamento è stato attivato.',
  'subscription.paymentCompleted': '🎉 Pagamento completato con successo!',
  'subscription.paymentCancelled': '❌ Pagamento annullato.',
  'subscription.paddleTestCards': 'Carte di test Paddle stampate nella console! (F12)',
  'subscription.sandboxTestCards': '🎴 CARTE DI TEST (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ CARTE DI TEST RIUSCITE:',
  'subscription.failedPaymentCards': '❌ CARTE DI TEST FALLITE:',
  'subscription.invalidCard': '📌 Carta non valida:',
  'subscription.sandboxOnly': '📝 NOTA: Queste carte funzionano solo nell\'ambiente Sandbox!',
  'subscription.enterCompanyName': 'Inserisci nome azienda',
  'subscription.enterPhone': 'Inserisci numero di telefono',
  'subscription.enterTaxNumber': 'Inserisci partita IVA',
  'subscription.selectPackage': 'Seleziona un pacchetto',
  'subscription.selectPlan': 'Seleziona un piano',
  'subscription.paddleNotLoaded': 'SDK Paddle non ancora caricato. Ricarica la pagina.',
  'subscription.paymentError': 'Errore di pagamento: ',
  'subscription.paymentCreationFailed': 'Impossibile creare il pagamento. Controlla i log della console.',
  'subscription.paddleConfigurationMissing': '⚠️ Configurazione Paddle mancante!',
  'subscription.paddleDashboardRequired': '⚠️ Configurazione Dashboard Paddle richiesta!',
  'subscription.paddleApiNotConfigured': 'Chiave API Paddle non configurata. Contatta l\'amministratore.',
  'subscription.cancelConfirm': 'Sei sicuro di voler annullare il tuo abbonamento? Il servizio continuerà fino alla fine del periodo di fatturazione.',
  'subscription.cancelSuccess': '✅ Abbonamento annullato. Il servizio continuerà fino alla fine del periodo di fatturazione.',
  'subscription.cancelFailed': 'Annullamento fallito',
  'subscription.region.turkey': '🇹🇷 Turchia',
  'subscription.region.europe': '🇪🇺 Europa',
  'subscription.region.other': '🌎 Altro',
  'subscription.status': 'Stato',
  'subscription.active': 'Attivo',
  'subscription.sandboxMode': '🧪 SANDBOX (Modalità Test)',
  'subscription.liveMode': '🚀 LIVE (Produzione)',
  'subscription.paddleActive': 'Attivo',
  'subscription.paddleConfigured': '✅ Sì',
  'subscription.paddleNotConfigured': '❌ No',
  'subscription.whatsappCreditsTitle': 'Crediti WhatsApp',
  'subscription.whatsappCreditsPackages': 'Pacchetti di Crediti',
  'subscription.whatsappCurrentBalance': 'Saldo Attuale',
  'subscription.whatsappCreditsAmount': '{count} Crediti',
  'subscription.whatsappPurchaseCredits': 'Acquista Crediti',
  
  // Invoices Page
  'invoices.title': 'Gestione Fatture',
  'invoices.subtitle': 'Visualizza e scarica le tue fatture di abbonamento',
  
  // Common Form Fields
  'form.color': 'Colore',
  'form.stain': 'Macchia',
  'form.damage': 'Danno',
  'form.notes': 'Note',
  'form.area': 'Area',
  
  // Stain Types
  'stain.blood': 'Sangue',
  'stain.oil': 'Olio',
  'stain.ink': 'Inchiostro',
  'stain.teaCoffee': 'Tè/Caffè',
  'stain.fruit': 'Frutta',
  'stain.rust': 'Ruggine',
  'stain.paint': 'Vernice',
  'stain.mud': 'Fango',
  'stain.salt': 'Sale',
  'stain.none': 'Nessuna',
  'stain.status': 'Stato macchia',
  'stain.multiple': 'Stato macchia (Selezione multipla)',
  'stain.other': 'Altro tipo di macchia (Premi Invio per aggiungere)...',
  
  // Expenses Page
  'expenses.title': 'Inserimento Spese',
  'expenses.addNew': 'Nuova Spesa',
  'expenses.total': 'Totale Spese',
  'expenses.totalToday': 'Totale Spese Odierne',
  'expenses.deletePermission': 'ℹ️ Il permesso di eliminare le spese appartiene solo al ruolo proprietario.',
  'expenses.description': 'Descrizione',
  'expenses.amount': 'Importo',
  'expenses.category': 'Categoria',
  'expenses.noExpenses': 'Nessuna spesa registrata oggi',
  'expenses.newExpense': 'Nuova Spesa',
  'expenses.descriptionLabel': 'Descrizione *',
  'expenses.amountLabel': 'Importo *',
  'expenses.categoryLabel': 'Categoria *',
  'expenses.categoryPlaceholder': 'Seleziona categoria...',
  'expenses.deleteTitle': 'Elimina Spesa',
  'expenses.deleteConfirm': 'Sei sicuro di voler eliminare questa spesa?',
  'expenses.descriptionField': 'Descrizione:',
  'expenses.categoryField': 'Categoria:',
  'expenses.amountField': 'Importo:',
  'expenses.dateField': 'Data:',
  'expenses.cancel': 'Annulla',
  'expenses.yesDelete': 'Sì, Elimina',
  'expenses.deleting': 'Eliminazione...',
  'expenses.saved': 'Spesa salvata',
  'expenses.saveError': 'Impossibile salvare la spesa',
  'expenses.deleted': 'Spesa eliminata',
  'expenses.deleteError': 'Impossibile eliminare la spesa',
  'expenses.loadError': 'Impossibile caricare le spese',
  'expenses.dateFilter': 'Filtro Data',
  'expenses.showDateFilter': 'Seleziona Intervallo Date',
  'expenses.startDate': 'Data Inizio',
  'expenses.endDate': 'Data Fine',
  'expenses.applyFilter': 'Filtra',
  'expenses.clearFilter': 'Cancella',
  'expenses.activeFilter': 'Filtro Attivo',
  'expenses.filterApplied': 'Filtro data applicato',
  'expenses.filterCleared': 'Filtro cancellato',
  'expenses.selectBothDates': 'Seleziona le date di inizio e fine',
  'expenses.canOnlyDeleteToday': 'Puoi eliminare solo le spese inserite oggi.',
  'expenses.myBranch': 'La mia filiale',
  'expenses.noBranchSelected': '— Nessuna filiale selezionata —',
  'expenses.branchSelect': 'Seleziona filiale',
  'expenses.excelError': 'Impossibile creare il file Excel',
  'expenses.exportExcel': 'Excel',
  'expenses.records': 'registrazioni',
  'expenses.categoryBy': 'Per categoria',
  'expenses.allTypes': 'Tutti i tipi',
  'expenses.noBranch': 'Senza filiale',
  'expenses.allBranches': 'Tutte le filiali',
  'expenses.expenseType': 'Tipo di spesa',
  
  // Z Report Page
  'zReport.title': 'Rapporto Z',
  'zReport.loadError': 'Impossibile caricare il rapporto',
  'zReport.loading': 'Caricamento...',
  'zReport.excelDownloaded': 'File Excel scaricato',
  'zReport.excelError': 'Impossibile creare file Excel',
  'zReport.singleDay': 'Giorno Singolo',
  'zReport.dateRange': 'Intervallo Date',
  'zReport.startDate': 'Inizio',
  'zReport.endDate': 'Fine',
  'zReport.totalOrders': 'Totale Ordini',
  'zReport.totalRevenue': 'Fatturato Totale',
  'zReport.paymentMethods': 'Metodi di Pagamento',
  'zReport.cash': 'Contanti',
  'zReport.creditCard': 'Carta di Credito',
  'zReport.mealCard': 'Carta Pasto',
  'zReport.account': 'Conto',
  'zReport.onDelivery': 'Alla Consegna',
  'zReport.collectionDetails': 'Dettagli Incasso',
  'zReport.orderCollections': 'Incassi Ordini',
  'zReport.accountCollections': 'Incassi Conto',
  'zReport.bankTransfer': 'Bonifico Bancario',
  'zReport.totalCollection': 'Incasso Totale',
  'zReport.expenses': 'Spese',
  'zReport.noExpenses': 'Nessuna spesa registrata',
  'zReport.totalExpenses': 'Spese Totali',
  'zReport.cancelledReceipts': 'Scontrini Annullati',
  'zReport.reason': 'Motivo',
  'zReport.noCancelled': 'Nessuno scontrino annullato',
  'zReport.totalCancelled': 'Totale Annullati ({count} Scontrini)',
  'zReport.cashRegister': 'Registro Cassa',
  'zReport.startingCash': 'Cassa Iniziale',
  'zReport.dailyCashIncome': 'Incasso Giornaliero',
  'zReport.cashToDeliver': 'Cassa da Consegnare',
  'zReport.deliveryCash': 'Contanti alla Consegna',
  'zReport.deliveryCard': 'Carta alla Consegna',
  'zReport.collectedItems': 'Articoli Riscossi',
  'zReport.serviceBreakdown': 'Ripartizione Servizi',
  'zReport.infoNote': 'Solo informativo',
  'zReport.paidAtRegister': 'Pagato alla Registrazione',
  'zReport.paidAtDelivery': 'Pagato alla Consegna',
  'zReport.orderPaidAtRegister': 'Ordini pagati alla registrazione',
  'zReport.orderPaidAtDelivery': 'Ordini pagati alla consegna',
  'zReport.totalPaidInRegister': 'Totale pagato alla registrazione',
  'zReport.totalPaidInDelivery': 'Totale pagato alla consegna',
  'zReport.free': 'Gratuito',
  // Account Statement Page
  'accountStatement.title': 'Estratto Conto',
  'accountStatement.subtitle': 'Tracciamento debiti e crediti per cliente',
  'accountStatement.selectCustomer': 'Seleziona Cliente',
  'accountStatement.customerPlaceholder': 'Seleziona cliente...',
  'accountStatement.searchCustomer': 'Cerca per nome, telefono o indirizzo...',
  'accountStatement.noCustomerSelected': 'Seleziona un cliente',
  'accountStatement.currentBalance': 'Saldo Attuale',
  'accountStatement.totalDebt': 'Debito Totale',
  'accountStatement.totalPayments': 'Totale Pagamenti',
  'accountStatement.transactions': 'Transazioni',
  'accountStatement.noTransactions': 'Nessuna transazione trovata per questo cliente',
  'accountStatement.date': 'Data',
  'accountStatement.description': 'Descrizione',
  'accountStatement.debit': 'Debito',
  'accountStatement.credit': 'Credito',
  'accountStatement.balance': 'Saldo',
  'accountStatement.order': 'Ordine',
  'accountStatement.payment': 'Pagamento',
  'accountStatement.loadError': 'Impossibile caricare l\'estratto conto',
  'accountStatement.addPayment': 'Aggiungi Pagamento',
  'accountStatement.paymentAmount': 'Importo Pagamento',
  'accountStatement.paymentMethod': 'Metodo di Pagamento',
  'accountStatement.paymentNotes': 'Descrizione (Opzionale)',
  'accountStatement.recordPayment': 'Registra Pagamento',
  'accountStatement.paymentSaved': 'Pagamento registrato',
  'accountStatement.paymentError': 'Impossibile registrare il pagamento',
  'accountStatement.selectCustomerFirst': 'Seleziona prima un cliente',
  'accountStatement.exportStatement': 'Scarica Estratto',
  'accountStatement.exportStatementPDF': 'Scarica PDF',
  'accountStatement.noCustomersFound': 'Nessun cliente trovato',
  'accountStatement.searchHint': 'Inserisci almeno 2 caratteri per cercare',
  'accountStatement.selectedCustomer': 'Cliente Selezionato',
  'accountStatement.changeCustomer': 'Cambia Cliente',
  
  // Notification Settings Page
  'notifications.title': 'Notifiche SMS/WhatsApp',
  'notifications.subtitle': 'Modifica le impostazioni di notifica SMS e WhatsApp',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'Connessione WhatsApp',
  'whatsapp.subtitle': 'Gestisci la tua connessione WhatsApp Business API',
  'whatsapp.connectionStatus': 'Stato Connessione',
  'whatsapp.disconnected': 'Non Connesso',
  'whatsapp.notConnectedMessage': 'Il tuo account WhatsApp non è ancora connesso',
  'whatsapp.connectWithQR': 'Connetti con Codice QR',
  'whatsapp.importantInfo': 'Informazioni Importanti',
  'whatsapp.info1': '1. Scansiona il codice QR con l\'app WhatsApp del tuo telefono',
  'whatsapp.info2': '2. Dopo la connessione, puoi inviare messaggi automatici',
  'whatsapp.info3': '3. Per disconnetterti, esci dalle impostazioni WhatsApp',
  'whatsapp.info4': '4. Il codice QR si rinnova automaticamente dopo 60 secondi',
  'whatsapp.generateQR': 'Genera Codice QR',
  
  // Profile Page
  'profile.subscriptionBilling': 'Abbonamento e Fatturazione',
  
  // Error Boundary
  'errorBoundary.unknownError': 'Si è verificato un errore',
  'errorBoundary.pageNotFound': 'Pagina Non Trovata',
  'errorBoundary.pageNotFoundDetails': 'La pagina che stai cercando non esiste o è stata spostata.',
  'errorBoundary.unauthorized': 'Accesso Non Autorizzato',
  'errorBoundary.unauthorizedDetails': 'Non sei autorizzato ad accedere a questa pagina.',
  'errorBoundary.forbidden': 'Accesso Negato',
  'errorBoundary.forbiddenDetails': 'Non hai permessi sufficienti per eseguire questa azione.',
  'errorBoundary.serverError': 'Errore Server',
  'errorBoundary.serverErrorDetails': 'Si è verificato un errore lato server. Riprova più tardi.',
  'errorBoundary.technicalDetails': 'Dettagli Tecnici',
  'errorBoundary.reload': 'Ricarica Pagina',
  'errorBoundary.goHome': 'Torna alla Home',
  'errorBoundary.persistentIssue': 'Se il problema persiste, contatta il team di supporto.',
  
  // Delivery
  'delivery.title': 'Gestione Consegne',
  'delivery.pending': 'In Corso',
  'delivery.ready': 'Pronto',
  'delivery.delivered': 'Consegnato',
  'delivery.orderNumber': 'N° Ordine',
  'delivery.customer': 'Cliente',
  'delivery.items': 'Prodotti',
  'delivery.total': 'Totale',
  'delivery.deliveryDate': 'Data di Consegna',
  'delivery.status': 'Stato',
  'delivery.actions': 'Azioni',
  'delivery.markReady': 'Segna come Pronto',
  'delivery.markDelivered': 'Segna come Consegnato',
  'delivery.printReceipt': 'Stampa Scontrino',
  
  // Delivery List Page
  'deliveryList.title': 'Elenco Consegne',
  'deliveryList.search': 'N° scontrino, nome cliente o telefono...',
  'deliveryList.all': 'Tutti',
  'deliveryList.pending': 'In Corso',
  'deliveryList.ready': 'Pronto',
  'deliveryList.date': 'Data',
  'deliveryList.pieces': 'Pezzi',
  'deliveryList.amount': 'Importo',
  'deliveryList.readyButton': 'Pronto',
  'deliveryList.receiptButton': 'Scontrino',
  'deliveryList.noOrders': 'Nessun ordine trovato',
  'deliveryList.statusUpdated': 'Ordine segnato come pronto',
  'deliveryList.statusUpdateError': 'Impossibile aggiornare lo stato',
  'deliveryList.loadError': 'Impossibile caricare gli ordini',
  'deliveryList.whatsappSending': '📱 Invio messaggio WhatsApp...',
  'deliveryList.smsSent': '📨 Messaggio SMS inviato',
  
  // Delivery Page
  'deliveryPage.title': 'Consegna',
  'deliveryPage.search': 'Cerca per n° scontrino, nome, telefono o indirizzo...',
  'deliveryPage.pieces': 'Pezzi',
  'deliveryPage.amount': 'Importo',
  'deliveryPage.payment': 'Pagamento',
  'deliveryPage.deliverButton': 'Consegna',
  'deliveryPage.noOrdersFound': 'Nessun ordine pronto per la consegna',
  'deliveryPage.noReadyOrders': 'Nessun ordine pronto per la consegna',
  'deliveryPage.minSearchLength': 'Inserisci almeno 3 caratteri per cercare',
  'deliveryPage.paymentDialogTitle': 'Pagamento alla Consegna',
  'deliveryPage.ordersLoadError': 'Impossibile caricare gli ordini',
  'deliveryPage.searchError': 'Impossibile cercare',
  'deliveryPage.deliverySuccess': 'Ordine consegnato',
  'deliveryPage.deliveryError': 'Consegna fallita',
  'deliveryPage.whatsappSending': '📱 Invio scontrino via WhatsApp...',
  'deliveryPage.statusNotReady': 'Ordine trovato ma non pronto per la consegna',
  'deliveryPage.statusPending': 'In Corso - Segna prima come pronto da "Elenco Consegne"',
  'deliveryPage.statusDelivered': 'Consegnato',
  'deliveryPage.statusCancelled': 'Annullato',
  'deliveryPage.receiptDelivered': '✅ *CONSEGNATO*',
  
  // Receipt Page
  'receipt.title': 'Scontrino ed Etichetta',
  'receipt.customerReceipt': 'Scontrino Cliente',
  'receipt.back': 'Indietro',
  'receipt.print': 'Stampa Scontrino',
  'receipt.whatsappSend': 'Invia WhatsApp',
  'receipt.receiptNumber': 'N° Scontrino',
  'receipt.date': 'Data',
  'receipt.time': 'Ora',
  'receipt.product': 'Prodotto',
  'receipt.quantity': 'Quantità',
  'receipt.price': 'Prezzo',
  'receipt.totalPieces': 'Totale Pezzi',
  'receipt.subtotal': 'Subtotale',
  'receipt.tax': 'IVA',
  'receipt.total': 'TOTALE',
  'receipt.payment': 'Pagamento',
  'receipt.plannedDelivery': 'Consegna Prevista',
  'receipt.notFound': 'Scontrino non trovato',
  'receipt.newOrder': 'Nuovo Ordine',
  'receipt.search': 'Ricerca e Ristampa Scontrino',
  'receipt.searchPlaceholder': 'Cerca per N° Scontrino, Nome Cliente o Telefono...',
  'receipt.searchEmpty': 'Inserisci un n° scontrino o nome cliente',
  'receipt.noResults': 'Nessun risultato trovato',
  'receipt.resultsCount': '{count} risultato/i trovato/i',
  'receipt.printButton': 'Stampa Scontrino',
  'receipt.products': 'prodotti',
  'receipt.loadError': 'Impossibile caricare i dati',
  'receipt.whatsappOpening': 'Apertura WhatsApp...',
  'receipt.labelPrinting': 'Stampa etichetta {current}/{total}...',
  'receipt.andLabel': 'ed Etichetta',
  'receipt.stain': 'Macchia',
  'receipt.damage': 'Danno',
  'receipt.taxPercent': 'IVA (%20)',
  'receipt.thankYou': 'Grazie!',

  // Payment Methods
  'payment.cash': 'Contanti',
  'payment.adjustment': 'Rettifica saldo',
  'payment.card': 'Carta di Credito (POS)',
  'payment.creditCard': 'Carta di Credito',
  'payment.mealCard': 'Buoni Pasto',
  'payment.onDelivery': 'Alla Consegna',
  'payment.account': 'Conto',
  'payment.splitPayment': 'Pagamento Rateale',
  'payment.addPayment': 'Aggiungi Pagamento',
  'payment.status': 'Stato Pagamento',
  'payment.pending': 'In Attesa',
  'payment.completed': 'Completato',
  'payment.partial': 'Pagamento Parziale',
  'payment.method': 'Metodo di Pagamento',
  'payment.amount': 'Importo',
  'payment.total': 'Totale',
  'payment.paid': 'Pagato',
  'payment.remaining': 'Rimanente',
  'payment.success': 'Pagamento riuscito',
  'payment.failed': 'Pagamento fallito',
  'payment.posPayment': 'Pagamento con Carta di Credito (Dispositivo POS)',
  'payment.posInstructions': 'Si prega di effettuare il pagamento dal cliente utilizzando il dispositivo POS.',
  'payment.posConfirm': 'Dopo aver ricevuto la conferma del pagamento dal dispositivo POS, fare clic sul pulsante "Conferma".',
  
  // Customers Page
  'customers.title': 'Clienti',
  'customers.addNew': 'Nuovo Cliente',
  'customers.search': 'Cerca Cliente...',
  'customers.name': 'Nome Cognome',
  'customers.phone': 'Telefono',
  'customers.email': 'E-mail',
  'customers.address': 'Indirizzo',
  'customers.totalOrders': 'Numero Ordini',
  'customers.totalSpent': 'Totale Speso',
  'customers.balance': 'Saldo',
  'customers.actions': 'Azioni',
  'customers.edit': 'Modifica',
  'customers.delete': 'Elimina',
  'customers.noCustomers': 'Nessun cliente trovato',
  'customers.noResults': 'Nessun risultato trovato',
  'customers.showingFirst50': 'Mostra i primi 50 risultati',
  'customers.totalResults': 'totale',
  'customers.tableCustomer': 'Cliente',
  'customers.tableContact': 'Contatto',
  'customers.tableAddress': 'Indirizzo',
  'customers.tableNotifications': 'Notifiche',
  'customers.tableBalance': 'Saldo',
  'customers.tableActions': 'Azioni',
  'customers.totalCount': 'Totale {count} clienti',
  'customers.notes': 'Nota',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Cerca per nome, telefono, email o indirizzo...',
  'customers.updated': 'Cliente aggiornato',
  'customers.updateError': 'Impossibile aggiornare il cliente',
  'customers.added': 'Cliente aggiunto',
  'customers.addError': 'Impossibile aggiungere il cliente',
  'customers.deleted': 'Cliente eliminato',
  'customers.deleteError': 'Impossibile eliminare il cliente',
  'customers.deleteConfirm': 'Sei sicuro di voler eliminare il cliente "{name}"?',
  'customers.loadError': 'Impossibile caricare i clienti',
  'customers.add': 'Nuovo Cliente',
  'customers.newCustomer': 'Nuovo Cliente',
  
  // Reports List Page
  'reportsList.totalReceipts': 'Totale Scontrini',
  'reportsList.registered': 'Registrazione',
  'reportsList.delivered': 'Consegna',
  'reportsList.totalRevenueExclCancelled': 'Fatturato Totale (no annullati)',
  'reportsList.activeOnly': 'Solo ordini attivi',
  'reportsList.orderStatus': 'Stato Ordine',
  // Customer Statement Page
  'customerStatement.receiptDelivered': 'Scontrino (Consegna)',
  'customerStatement.receiptOpen': 'Scontrino (Aperto)',
  
  // Settings Page
  'settings.title': 'Impostazioni',
  'settings.general': 'Impostazioni Generali',
  'settings.companyName': 'Nome Azienda',
  'settings.language': 'Lingua',
  'settings.currency': 'Valuta',
  'settings.currencyPosition': 'Posizione Valuta',
  'settings.currencyPositionLeft': 'Sinistra ($100.00)',
  'settings.currencyPositionRight': 'Destra (100.00₺)',
  'settings.currencyPositionPreview': 'Simbolo {position}: {example}',
  'settings.currencyPositionPreviewLeft': 'Simbolo a sinistra',
  'settings.currencyPositionPreviewRight': 'Simbolo a destra',
  'settings.numberFormat': 'Formato Numero',
  'settings.currencyFormat': 'Formato Valuta',
  'settings.showDecimals': 'Mostra Decimali',
  'settings.showDecimalsDesc': 'Mostra la parte decimale nei prezzi',
  'settings.dateFormat': 'Formato Data',
  'settings.deliveryDays': 'Tempo di Consegna (Giorni)',
  'settings.workOnSunday': 'Lavora la Domenica',
  'settings.defaultServiceType': 'Tipo di Servizio Predefinito',
  'settings.defaultServiceTypeDesc': 'Tipo di servizio automaticamente selezionato all\'apertura della schermata di registrazione prodotto',
  'settings.defaultCategory': 'Categoria Predefinita',
  'settings.defaultCategoryDesc': 'Categoria automaticamente selezionata all\'apertura della schermata di registrazione prodotto',
  'settings.companyLogo': 'Logo Aziendale',
  'settings.logoDescription': 'Il logo apparirà sugli scontrini e in alto a sinistra del programma. Dimensione consigliata: 200x80px',
  'settings.uploadLogo': 'Carica Logo',
  'settings.removeLogo': 'Rimuovi Logo',
  'settings.noLogo': 'Nessun logo',
  'settings.whatsappTemplates': 'Modelli Messaggi WhatsApp',
  'settings.smsTemplates': 'Modelli Messaggi SMS',
  'settings.orderCreated': 'Ordine Creato',
  'settings.orderReady': 'Ordine Pronto',
  'settings.orderDelivered': 'Ordine Consegnato',
  'settings.receiptSettings': 'Impostazioni Scontrino',
  'settings.showTax': 'Mostra IVA',
  'settings.taxRate': 'Aliquota IVA (%)',
  'settings.footerText': 'Testo Piè di Pagina',
  'settings.receiptFooterText': 'Piè di Pagina Scontrino',
  'settings.receiptNote': 'Nota Piè di Pagina Scontrino',
  'settings.socialMedia': 'Social Media & Contatti',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Sito Web',
  'settings.phone': 'Telefono',
  'settings.address': 'Indirizzo',
  'settings.dangerZone': 'Zona Pericolosa',
  'settings.deleteDemoDataWarning': 'Rimuove i clienti di esempio aggiunti automaticamente in fase di configurazione, insieme a ricevute e pagamenti. I clienti e le ricevute inseriti da voi non vengono eliminati.',
  'settings.productsWillBeKept': 'Le definizioni dei prodotti saranno conservate.',
  'settings.deleteDemoDataTitle': 'I Dati Demo Saranno Eliminati',
  'settings.deleteDemoDataConfirm': 'Questa operazione non può essere annullata! I clienti di esempio e le loro ricevute/pagamenti verranno eliminati; i vostri clienti e ricevute verranno mantenuti.',
  'toast.noDemoData': 'Nessun cliente di esempio da eliminare.',
  'toast.demoCustomersKept': '{n} cliente/i di esempio mantenuto/i perché hanno ricevute create da voi; sono state eliminate solo le ricevute di esempio.',
  'settings.areYouSure': 'Sei sicuro di voler continuare?',
  'settings.deleting': 'Eliminazione...',
  'settings.yesDelete': 'Sì, Elimina',
  'settings.deleteDemoData': 'Elimina Dati Demo',
  'settings.deleteDemoDataDesc': 'Questa azione eliminerà definitivamente tutti i clienti, ordini e pagamenti demo.',
  'settings.deleteButton': 'Elimina Dati Demo',
  'settings.save': 'Salva',
  'settings.loading': 'Caricamento...',
  'settings.languageRegion': 'Lingua e regione',
  'settings.numberFormatDotComma': 'Punto per decimali (1.234,56)',
  'settings.numberFormatCommaDot': 'Virgola per decimali (1,234.56)',
  'settings.numberFormatSpaceComma': 'Spazio per decimali (1 234,56)',
  'settings.timezone': 'Fuso orario',
  'settings.logo': 'Logo',
  'settings.companyNamePlaceholder': 'Inserisci il nome azienda',
  'settings.addressPlaceholder': 'Inserisci l\'indirizzo',
  'settings.footerTextPlaceholder': 'Inserisci il testo piè di pagina',
  'settings.receiptNotePlaceholder': 'Inserisci la nota ricevuta',
  'settings.loadSchema': 'Carica schema',
  'settings.loadSchemaTitle': 'Carica schema database',
  'settings.loadSchemaConfirm': 'Questo creerà lo schema database. Continuare?',
  'settings.connected': 'Connesso',
  'settings.notConnected': 'Non connesso',
  'settings.connect': 'Connetti',
  'settings.disconnect': 'Disconnetti',
  
  // Toasts
  'toast.settingsSaved': 'Impostazioni salvate',
  'toast.settingsError': 'Impossibile salvare le impostazioni',
  'toast.settingsLoadError': 'Impossibile caricare le impostazioni',
  'toast.logoUploaded': 'Logo caricato. Non dimenticare di salvare!',
  'toast.logoRemoved': 'Logo rimosso. Non dimenticare di salvare!',
  'toast.logoSizeError': 'Il file logo deve essere inferiore a 500KB',
  'toast.logoTypeError': 'Solo file immagine possono essere caricati',
  'toast.demoDataDeleted': 'Dati demo eliminati',
  'toast.demoDataDeleteError': 'Impossibile eliminare i dati demo',
  'toast.orderCreated': 'Ordine creato',
  'toast.orderError': 'Impossibile creare l\'ordine',
  'toast.customerAdded': 'Cliente aggiunto',
  'toast.customerError': 'Impossibile aggiungere il cliente',
  'toast.productAdded': 'Prodotto aggiunto',
  'toast.productError': 'Impossibile aggiungere il prodotto',
  'toast.qrGenerated': 'Codice QR generato. Scansiona con la tua app WhatsApp Business.',
  'toast.qrError': 'Impossibile generare il codice QR',
  'toast.whatsappConnected': 'WhatsApp Business connesso con successo!',
  'toast.whatsappDisconnected': 'Connessione WhatsApp Business disconnessa',
  'toast.connectionError': 'Impossibile salvare la connessione',
  'toast.disconnectError': 'Impossibile disconnettere',
  'toast.connectionStatusError': 'Impossibile caricare lo stato della connessione',
  'toast.orderSaved': 'Ordine salvato',
  'toast.orderSaveError': 'Impossibile salvare l\'ordine',
  'toast.statsError': 'Impossibile caricare le statistiche',
  'toast.userAdded': 'Utente aggiunto',
  'toast.userAddError': 'Impossibile aggiungere l\'utente',
  'toast.userUpdated': 'Utente aggiornato',
  'toast.userUpdateError': 'Impossibile aggiornare l\'utente',
  'toast.usersLoadError': 'Impossibile caricare gli utenti',
  'toast.pinChanged': 'Codice PIN modificato',
  'toast.pinChangeError': 'Impossibile modificare il codice PIN',
  'toast.userDeleted': 'Utente eliminato/disattivato con successo',
  'toast.userDeleteError': 'Impossibile eliminare l\'utente',
  'toast.productsLoadError': 'Errore nel caricamento dei prodotti',
  'toast.orderDetailsLoadError': 'Errore nel caricamento dei dettagli dell\'ordine',
  'toast.orderLoadError': 'Errore nel caricamento dell\'ordine',
  'toast.deliveryBeforeToday': 'La data di consegna non può essere precedente a oggi',
  'toast.customerOpenOrders': 'Il cliente ha {count} ordini aperti',
  'toast.customerDebt': 'Il cliente ha un debito di {amount}',
  'toast.customerSaved': 'Cliente salvato',
  'toast.customerSaveError': 'Errore nel salvataggio del cliente',
  'toast.customerUpdated': 'Cliente aggiornato',
  'toast.customerUpdateError': 'Errore nell\'aggiornamento del cliente',
  'toast.customerExistingSelected': 'Cliente esistente selezionato',
  'toast.productAddedToCart': 'Prodotto aggiunto al carrello',
  'toast.productDetailsUpdated': 'Dettagli prodotto aggiornati',
  'toast.priceUpdated': 'Prezzo aggiornato',
  'toast.selectAtLeastOneService': 'Seleziona almeno un servizio',
  'toast.selectCustomer': 'Seleziona un cliente',
  'toast.addProduct': 'Aggiungi un prodotto',
  'toast.addressRequiredForDelivery': 'Indirizzo richiesto per la consegna',
  'toast.cardPaymentSuccess': 'Pagamento con carta riuscito!',
  'toast.cardPaymentError': 'Pagamento con carta fallito',
  'toast.paymentFailedTryAgain': 'Pagamento fallito. Riprova.',
  'toast.paymentStatusCheckFailed': 'Impossibile verificare lo stato del pagamento.',
  'toast.customerPhoneNotFound': 'Telefono cliente non trovato',
  'toast.whatsappSent': 'Messaggio WhatsApp inviato! ✅',
  'toast.whatsappFailed': 'Invio messaggio WhatsApp fallito',
  'toast.orderUpdateError': 'Aggiornamento ordine fallito',
  'toast.searchError': 'Errore di ricerca',
  'toast.orderNotFound': 'Ordine non trovato',
  'toast.editCancelled': 'Modifica annullata',
  'toast.noEditPermission': 'Non hai il permesso di modificare gli ordini passati',
  'toast.selectAtLeastOneOperation': 'Seleziona almeno un\'operazione',
  'toast.tailorAddedToCart': 'Operazione di sartoria aggiunta al carrello',
  'toast.enterValidArea': 'Inserisci un\'area valida',
  'toast.enterValidAmount': 'Inserisci un importo valido',
  'toast.amountExceedsRemaining': 'L\'importo non può superare il saldo rimanente',
  'toast.fillAllCardInfo': 'Compila tutte le informazioni della carta',
  'toast.invalidCardNumber': 'Numero carta non valido',
  'toast.invalidMonth': 'Mese non valido (deve essere 1-12)',
  'toast.invalidYear': 'Anno non valido',
  'toast.invalidCvc': 'CVC non valido',
  
  // Subscription Banner
  'subscription.warning': 'Avviso Abbonamento',
  'subscription.expiringDays': 'Il tuo abbonamento scade tra {days} giorni. Rinnova per continuare senza interruzioni.',
  'subscription.renew': 'Rinnova Abbonamento',
  
  // Common
  'common.yes': 'Sì',
  'common.no': 'No',
  'common.cancel': 'Annulla',
  'common.confirm': 'Conferma',
  'common.delete': 'Elimina',
  'common.edit': 'Modifica',
  'common.save': 'Salva',
  'common.search': 'Cerca',
  'common.loading': 'Caricamento...',
  'common.noData': 'Nessun dato',
  'common.actions': 'Azioni',
  'common.status': 'Stato',
  'common.date': 'Data',
  'common.time': 'Ora',
  'common.total': 'Totale',
  'common.filter': 'Filtra',
  'common.export': 'Esporta',
  'common.print': 'Stampa',
  'common.close': 'Chiudi',
  'common.back': 'Indietro',
  'common.next': 'Successivo',
  'common.previous': 'Precedente',
  'common.submit': 'Invia',
  'common.reset': 'Ripristina',
  'common.create': 'Crea',
  'common.creating': 'Creazione...',
  'common.later': 'Dopo',
  'common.clear': 'Cancella',
  'common.copied': 'Copiato!',
  'common.copyError': 'Copia fallita',
  'common.perPage': 'Per pagina',
  'common.page': 'Pagina',
  'common.orders': 'Ordini',
  'common.pieces': 'pezzi',
  
  // Tickets
  'tickets.title': 'Richieste di Supporto',
  'tickets.newTicket': 'Nuova Richiesta',
  'tickets.noTickets': 'Nessuna richiesta di supporto',
  'tickets.noTicketsDesc': 'Se hai un problema, puoi creare una nuova richiesta di supporto',
  'tickets.subject': 'Oggetto',
  'tickets.description': 'Descrizione',
  'tickets.yourName': 'Il Tuo Nome',
  'tickets.yourNamePlaceholder': 'Inserisci il tuo nome',
  'tickets.subjectPlaceholder': 'Riassumi brevemente il tuo problema',
  'tickets.descriptionPlaceholder': 'Descrivi il tuo problema in dettaglio',
  'tickets.created': 'Richiesta di supporto creata',
  'tickets.createError': 'Impossibile creare la richiesta di supporto',
  'tickets.fillAllFields': 'Compila tutti i campi',
  'tickets.loadError': 'Impossibile caricare i ticket',
  'tickets.messages': 'messaggi',
  'tickets.status.open': 'Aperto',
  'tickets.status.investigating': 'In Investigazione',
  'tickets.status.waitingCustomer': 'In Attesa di Risposta Cliente',
  'tickets.status.closed': 'Risolto',
  'tickets.conversation': 'Conversazione',
  'tickets.admin': 'Team di Supporto',
  'tickets.typeMessage': 'Scrivi il tuo messaggio...',
  'tickets.sendError': 'Impossibile inviare il messaggio',
  'tickets.closedMessage': 'Questa richiesta è stata contrassegnata come risolta.',
  'tickets.rateSupport': 'Valuta il Supporto',
  'tickets.rateExperience': 'Valuta la Tua Esperienza',
  'tickets.rateDescription': 'Come valuti il supporto ricevuto?',
  'tickets.selectRating': 'Seleziona una valutazione',
  'tickets.ratingSubmitted': 'La tua valutazione è stata registrata, grazie!',
  'tickets.ratingError': 'Impossibile inviare la valutazione',
  'tickets.yourRating': 'La Tua Valutazione',
  'tickets.rating.veryBad': 'Pessimo',
  'tickets.rating.bad': 'Cattivo',
  'tickets.rating.okay': 'Sufficiente',
  'tickets.rating.good': 'Buono',
  'tickets.rating.excellent': 'Eccellente',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Sistema di Gestione Lavanderia a Secco',
  'login.tenantId': 'ID Azienda',
  'login.tenantPlaceholder': 'id-azienda (es: acme-clean)',
  'login.tenantIdHelp': 'Inserisci il tuo identificativo univoco aziendale',
  'login.continue': 'Continua →',
  'login.notMember': 'Non sei ancora membro?',
  'login.startTrial': 'Inizia Prova Gratuita',
  'login.adminLogin': '🔒 Accesso Amministratore',
  'login.enterPin': 'Inserisci il tuo codice PIN',
  'login.changeTenant': 'Cambia Azienda',
  'login.clear': 'Cancella',
  'login.delete': 'Elimina',
  'login.login': 'Accedi',
  'login.loggingIn': 'Accesso...',
  'login.defaultPinOwner': 'PIN predefinito: <strong>1234</strong> (Proprietario)',
  'login.defaultPinCashier': 'PIN predefinito: <strong>0000</strong> (Cassiere)',
  'login.systemInitializing': 'Inizializzazione sistema...',
  'login.pinMinLength': 'Il PIN deve contenere almeno 4 cifre',
  'login.invalidTenantId': 'Inserisci un ID azienda valido',
  'login.tenantNotFound': 'Questo codice azienda non è stato trovato. Verifica o crea un nuovo account.',
  'login.loginFailed': 'Accesso fallito',
  'login.welcome': 'Benvenuto, {name}',

  // Signup translations
  'signup.title': 'Inizia Prova Gratuita',
  'signup.subtitle': 'Prova gratuita di 15 giorni, nessuna carta di credito richiesta',
  'signup.backToLogin': 'Torna alla Pagina di Accesso',
  'signup.companyCode': 'Codice Azienda',
  'signup.companyCodePlaceholder': 'es: cleanpro',
  'signup.companyCodeHelp': 'Questo codice sarà utilizzato per accedere al sistema',
  'signup.companyCodeMinLength': 'Il codice azienda deve contenere almeno 3 caratteri',
  'signup.companyName': 'Nome Azienda',
  'signup.companyNamePlaceholder': 'Nome della Tua Azienda',
  'signup.companyNameRequired': 'Il nome dell\'azienda è richiesto',
  'signup.fullName': 'Nome Cognome',
  'signup.fullNamePlaceholder': 'Il Tuo Nome Cognome',
  'signup.fullNameRequired': 'Il nome cognome è richiesto',
  'signup.phone': 'Telefono',
  'signup.phonePlaceholder': '+39 333 123 4567',
  'signup.validPhoneRequired': 'Inserisci un numero di telefono valido',
  'signup.email': 'E-mail',
  'signup.emailPlaceholder': 'esempio@azienda.com',
  'signup.validEmailRequired': 'Inserisci un indirizzo e-mail valido',
  'signup.createAccount': 'Crea Account',
  'signup.creating': 'Creazione...',
  'signup.terms': 'Creando un account, accetti i Termini di Servizio e la Privacy Policy.',
  'signup.success': 'Registrazione riuscita! Le tue informazioni di accesso sono state inviate al tuo indirizzo e-mail.',
  'signup.successTitle': 'Registrazione Riuscita!',
  'signup.successMessage': 'Il tuo account è stato creato con successo.',
  'signup.emailSent': 'Le tue informazioni di accesso sono state inviate al tuo indirizzo e-mail.',
  'signup.redirecting': 'Reindirizzamento alla pagina di accesso...',
  'signup.startupPackageLoaded': 'Pacchetto di Avvio Caricato!',
  'signup.products': 'Prodotti',
  'signup.customers': 'Clienti',
  'signup.users': 'Utenti',
  'signup.demoDataReady': '✨ I tuoi dati demo sono pronti, puoi iniziare a usarli subito!',
  'signup.loginInfo': '📧 Le Tue Informazioni di Accesso',
  'signup.loginInfoSent': '💡 Queste informazioni sono state inviate anche al tuo indirizzo e-mail',
  'signup.loginNow': 'Accedi Ora →',
  'signup.hints.companyCode': 'Utilizzato per l\'accesso',
  'signup.hints.country': 'Il tuo paese è stato rilevato automaticamente. Puoi selezionare un paese diverso.',
  'signup.freeTrial': '🎉 Prova gratis per 15 giorni - Nessuna carta di credito richiesta!',
  'signup.bt.tailoring.desc': 'Sartoria, modifiche e servizi di cucito',
  'signup.bt.barber.desc': 'Parrucchiere, barbiere e salone di bellezza',
  'signup.businessType.question': 'Che tipo di attività hai?',
  'signup.businessType.hint': 'La schermata predefinita verrà impostata automaticamente in base alla tua scelta',
  'signup.businessType.continue': 'Continua',
  'signup.bt.dryCleaning.desc': 'Pulizia di abiti, tende e tessuti',
  'signup.bt.carpetWashing.desc': 'Lavaggio di tappeti, moquette e passatoie',
  'signup.bt.sofaWashing.desc': 'Pulizia di divani, poltrone e sedute',
  'signup.bt.carWash.desc': 'Lavaggio, ceratura, lucidatura e detailing auto',
  'signup.bt.shoeShine.desc': 'Pulizia e cura delle scarpe',
  'signup.companyDetails': 'Dati aziendali',
  'signup.errors.companyCodeRequired': 'Il codice azienda è obbligatorio',
  'signup.errors.companyCodeTooShort': 'Il codice azienda deve avere almeno 3 caratteri',
  'signup.errors.companyNameRequired': 'Il nome azienda è obbligatorio',
  'signup.errors.emailInvalid': 'Inserisci un indirizzo e-mail valido',
  'signup.errors.emailRequired': 'L’indirizzo e-mail è obbligatorio',
  'signup.errors.ownerNameRequired': 'Nome e cognome obbligatori',
  'signup.errors.signupFailed': 'Registrazione non riuscita',
  'signup.fields.companyCode': 'Codice azienda',
  'signup.fields.companyName': 'Nome azienda',
  'signup.fields.country': 'Paese',
  'signup.fields.email': 'Indirizzo e-mail',
  'signup.fields.ownerName': 'Nome e cognome',
  'signup.fields.phone': 'Numero di telefono',
  'signup.haveAccount': 'Hai già un account? Accedi',
  'signup.placeholders.companyCode': 'es.: cleanpro',
  'signup.placeholders.companyName': 'es.: CleanPro Lavanderia',
  'signup.placeholders.email': 'es.: mario@cleanpro.com',
  'signup.placeholders.ownerName': 'es.: Mario Rossi',
  'signup.placeholders.phone': 'es.: +39 312 345 6789',
  'signup.referral.bonus': 'Bonus invito',
  'signup.referral.title': 'Codice invito',
  
  // Z-Report
  'zReport.cancelledOrders': 'Ordini annullati',
  'zReport.incoming': 'Entrante',
  'zReport.outgoing': 'Uscente',
  'zReport.totalRegistered': 'Totale registrato',
  'zReport.todayOrders': 'Ordini di oggi',
  'zReport.registrationAndDelivery': 'Registrazione + Consegna',
  'zReport.cashCalculation': '(Inizio + Cash odierno - Spese)',

  'zReport.cashBoxStartNote': 'Saldo iniziale di cassa',
  'zReport.todayCashNote': 'Contanti ricevuti oggi',
  'zReport.branchCollectionsNote': 'Incassi propri + altre filiali',
  'zReport.dailyExpensesNote': 'Spese giornaliere',
  'customerCard.balanceZero': 'Il saldo è già zero.',
  'customerCard.debtLabel': 'il debito verrà azzerato',
  'customerCard.creditLabel': 'il credito verrà azzerato',
  'customerCard.resetConfirm': 'Il saldo verrà azzerato ({label}). Confermare?',
  'customerCard.resetSuccess': 'Saldo azzerato con successo',
  'customerCard.resetError': 'Impossibile azzerare il saldo',
  'customerCard.printTitle': 'Scheda Cliente',
  'customerCard.heading': 'SCHEDA CLIENTE',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerCard.address': 'INDIRIZZO',
  'customerCard.printButton': 'Stampa scheda cliente',
  'customerCard.resetting': 'Azzeramento...',
  'customerCard.resetBalance': 'Azzera saldo',
  'tailoring.loadError': 'Impossibile caricare i prezzi',
  'tailoring.nameRequired': "Inserire il nome dell'operazione",
  'tailoring.invalidPrice': 'Inserire un prezzo valido',
  'tailoring.addSuccess': 'Nuova operazione di sartoria aggiunta!',
  'tailoring.saveError': 'Errore di salvataggio',
  'tailoring.deleteConfirm': 'Sei sicuro di voler eliminare questa operazione?',
  'tailoring.deleteSuccess': 'Operazione eliminata',
  'tailoring.deleteError': 'Errore di eliminazione',
  'tailoring.saveSuccess': 'Prezzi di sartoria salvati!',
  'tailoring.addNewTitle': 'Aggiungi nuova operazione di sartoria',
  'tailoring.operationNameLabel': 'Nome operazione',
  'tailoring.priceLabel': 'Prezzo',
  'tailoring.iconLabel': 'Icona (Emoji)',
  'tailoring.operationNamePlaceholder': 'Es: Cucitura colletto',
  'tailoring.savePricesHint': 'Clicca su Salva per salvare i prezzi',
  'tailoring.addCustomHint': "Usa il pulsante + per aggiungere un'operazione personalizzata",
  'reportsList.title': 'Elenco ricevute',
  'reportsList.startDate': 'Data inizio',
  'reportsList.endDate': 'Data fine',
  'reportsList.search': 'Cerca',
  'reportsList.loading': 'Caricamento...',
  'reportsList.description': 'Sono elencate tutte le ricevute registrate o consegnate in questo intervallo di date',
  'reportsList.empty': 'Nessuna ricevuta trovata in questo intervallo di date',
  'reportsList.changeDateRange': 'Seleziona un intervallo di date diverso',
  'reportsList.categoryBreakdown': 'Suddivisione per categoria',
  'reportsList.unknown': 'Sconosciuto',
  'reportsList.cancelReason': 'Motivo di annullamento:',
  'reportsList.excelDownloaded': 'File Excel scaricato',
  'reportsList.excelError': 'Impossibile creare il file Excel',
  'reportsList.totalReceipt': 'Totale ricevute',
  'reportsList.activeReceipt': 'Ricevute attive',
  'reportsList.loadError': "Impossibile caricare l'elenco ricevute",
  'reportsList.dateError': 'La data di inizio non può essere successiva alla data di fine',
  'charts.revenue': 'Fatturato',
  'charts.orders': 'Ordini',
  'charts.pieces': 'Numero pezzi',
  'charts.receipts': 'Numero ricevute',
  'charts.loadError': 'Impossibile caricare i dati',

  'customerStatement.selectDateRange': 'Seleziona intervallo di date',
  'customerStatement.thisMonth': 'Questo mese',
  'customerStatement.lastMonth': 'Mese scorso',
  'customerStatement.allTime': 'Tutto il periodo',
  'customerStatement.startDate': 'Data inizio',
  'customerStatement.endDate': 'Data fine',
  'customerStatement.printPDF': 'Stampa estratto (PDF)',
  'customerStatement.title': 'ESTRATTO CONTO',
  'customerStatement.customerName': 'Nome cliente',
  'customerStatement.phone': 'Telefono',
  'customerStatement.address': 'Indirizzo',
  'customerStatement.openingBalance': 'Saldo iniziale',
  'customerStatement.closingBalance': 'Saldo finale',
  'customerStatement.description': 'Descrizione',
  'customerStatement.type': 'Tipo',
  'customerStatement.debit': 'Dare',
  'customerStatement.credit': 'Avere (incassato)',
  'customerStatement.total': 'TOTALE',
  'customerStatement.cancelled': 'ANNULLATO',
  'customerStatement.payment': 'Pagamento',
  'customerStatement.items': 'articoli',
  'customerStatement.noTransactions': 'Nessuna transazione nel periodo selezionato.',
  'customerStatement.statementDate': 'Data estratto',

  'tailoring.subtitle': 'Qui puoi aggiornare i prezzi dei servizi sartoriali',
  'tailoring.addNewDescription': 'Aggiungere un tipo di operazione sartoriale personalizzato',
  'tailoring.add': 'Aggiungi',
  'tailoring.savePrices': 'Salva prezzi',
  'tailoring.default': 'Predefinito',
  'tailoring.infoTitle': 'Informazione',
  'tailoring.info1': 'Dopo aver modificato i prezzi, clicca su "Salva prezzi"',
  'tailoring.info2': 'Con "Nuova Operazione" puoi aggiungere tipi di operazioni sartoriali personalizzate',
  'tailoring.info3': 'Le operazioni personalizzate possono essere eliminate con l\'icona del cestino',
  'tailoring.info4': 'Questi prezzi vengono utilizzati nella creazione degli ordini con servizio sartoriale',
  'tailoring.info5': 'Puoi impostare un prezzo separato per ogni operazione sartoriale',
  'tailoring.info6': 'I prezzi vengono calcolati automaticamente all\'aggiunta al carrello',

  'hardware.title': 'Negozio Hardware',
  'hardware.subtitle': 'Stampanti ricevute, etichette e dispositivi Caller ID',
  'hardware.cart': 'Carrello',
  'hardware.infoTitle': 'Informazione',
  'hardware.infoText': 'Questi prodotti hardware sono attualmente disponibili per l\'acquisto solo in Turchia. Sono elencati a scopo informativo per altri paesi.',
  'hardware.myCart': 'Il mio carrello',
  'hardware.cartEmpty': 'Carrello vuoto',
  'hardware.vatSuffix': '+ IVA',
  'hardware.total': 'Totale',
  'hardware.checkout': 'Procedi al pagamento',
  'hardware.receiptPrinters': 'Stampanti ricevute',
  'hardware.receiptPrintersSubtitle': 'Stampanti termiche 80mm con taglierino automatico',
  'hardware.compatibilityTitle': 'Compatibilità CleandySoft',
  'hardware.receiptCompatText': 'Funziona con tutte le stampanti termiche 80mm con taglierino automatico.',
  'hardware.labelPrinters': 'Stampanti etichette',
  'hardware.labelPrintersSubtitle': 'Stampanti a matrice, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Modelli testati',
  'hardware.labelCompatText': 'Testato per Epson TM-U220 e Bixolon SRP-270. Altre marche o modelli possono avere problemi.',
  'hardware.callerIdTitle': 'Dispositivi Caller ID',
  'hardware.callerIdSubtitle': 'Identificazione chiamate clienti',
  'hardware.compatibilityNote': 'Nota di compatibilità',
  'hardware.callerIdCompatText': 'Testato solo per il modello CIDShow 2 linee. Altre marche o modelli potrebbero funzionare ma non sono garantiti.',
  'hardware.barcodeScanners': 'Scanner codici a barre',
  'hardware.barcodeScannerSubtitle': 'Scanner USB codici a barre e QR',
  'hardware.barcodeCompatText': 'Tutti gli scanner 2D possono funzionare con CleandySoft. Gli scanner in modalità USB HID sono supportati automaticamente.',
  'hardware.driverDownloads': 'Download driver e software',
  'hardware.driverDownloadsText': 'Si raccomanda di scaricare il driver appropriato prima di collegare la stampante.',
  'hardware.onlyTurkey': 'Questo prodotto è disponibile per l\'acquisto solo in Turchia',
  'hardware.addedToCart': 'Aggiunto al carrello!',
  'hardware.available': 'Disponibile',
  'hardware.info': 'Info',
  'hardware.features': 'Caratteristiche',
  'hardware.addToCart': 'Aggiungi al carrello',
  'hardware.infoOnly': 'Solo informativo',

  // Payment dialog
  'order.selectPaymentMethod': 'Seleziona il metodo di pagamento',
  'payment.amountToPay': 'Importo da pagare',
  'payment.enterAmount': 'Inserisci l\'importo del pagamento',
  'payment.madePayments': 'Pagamenti effettuati',
  'payment.free': 'Gratuito',
  'toast.selectPaymentMethodFirst': 'Seleziona prima un metodo di pagamento',
  'nav.logout': 'Esci',
  'logout': 'Esci',

  // Order screen
  'orderCreate.selectOperation': 'Seleziona operazione (i prezzi verranno aggiunti automaticamente)',
  'orderCreate.selectedOperations': 'Operazioni selezionate',
  'orderCreate.discount': 'Sconto',
  'orderCreate.discountLabel': 'Sconto (%)',
  'orderCreate.debt': 'Debito',
  'orderCreate.credit': 'Credito',
  'orderCreate.homeDelivery': 'Consegna a domicilio',
  'orderCreate.homeDeliveryAddress': 'Indirizzo',
  'orderCreate.addressRequired': 'Indirizzo obbligatorio!',
  'orderCreate.pickupFromAddress': 'L\'autista ritirerà all\'indirizzo',
  'orderCreate.subtotal': 'Subtotale',
  'orderCreate.grandTotal': 'Totale generale',
  'common.unit': 'Unità',
  'subscription.referralDesc': 'Quando un amico che inviti si registra e diventa membro, ottieni 1 mese extra! Inviare l’invito non basta.',
  'dashboard.referral.desc': '1 mese extra quando un’attività invitata si registra!',
};
